import { render, staticRenderFns } from "./Lgx192601381150916608.vue?vue&type=template&id=34652645&"
import script from "./Lgx192601381150916608.vue?vue&type=script&lang=js&"
export * from "./Lgx192601381150916608.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports